<template>
    <keep-alive>
        <div id="modal" class="modal_size">
            <a href="javascript:" class="ui_close" type="button" rel="modal:close" @click="$emit('close')"
                ><span class="sr_only"></span
            ></a>
            <dl class="modal_content">
                <dt class="ellipsis maintit">
                    <i>{{ title }}</i>
                </dt>
                <dd>
                    <div class="view_cont">
                        <table class="data_table">
                            <colgroup>
                                <col width="*" />
                                <col width="*" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>{{ $t('FIELD.EXCEL.RAWDATA.NO') }}</th>
                                    <th>{{ $t('FIELD.GLOBAL.FILE.NAME') }}</th>
                                </tr>
                            </thead>
                            <tbody class="text_center">
                                <tr v-for="(excel, index) in excelFiles" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td class="text_left">
                                        <a href="javascript:" @click="excelDownload(excel)">{{ excel }}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">{{
                                $t('BUTTON.GLOBAL.CLOSE')
                            }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </keep-alive>
</template>
<script>
import Vue from 'vue';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';

export default {
    name: 'ExcelDownloadPopup',
    props: {
        title: {},
        excelFiles: {},
    },
    methods: {
        excelDownload(fileName) {
            let formData = { file_name: fileName };
            const getFileName = contentDisposition => {
                const fileName = contentDisposition
                    .split(';')
                    .filter(ele => ele.indexOf('filename') > -1)
                    .map(ele => ele.replace(/"/g, '').split('=')[1]);

                return fileName[0] ? fileName[0] : null;
            };

            return axios
                .post(`${SDLUtil.API_URL}/basis/common/excelDownload.skp`, qs.stringify(formData), {
                    responseType: 'blob',
                })
                .then(response => {
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    let fileName = '';
                    if (response.headers['content-disposition']) {
                        fileName = getFileName(response.headers['content-disposition']);
                    } else {
                        // eslint-disable-next-line prefer-destructuring
                        fileName = fileName;
                    }

                    fileName = decodeURI(fileName); // File name decoding (option of use according to project)

                    if (window.navigator.msSaveOrOpenBlob) {
                        // IE 10+
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        // not IE
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.target = '_self';
                        if (fileName) link.download = fileName;
                        link.click();
                    }
                });
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/ExcelDownloadPopup.vue